import { render } from "./BaseCreateDialogTranslations.vue?vue&type=template&id=5c706d67"
import script from "./BaseCreateDialogTranslations.vue?vue&type=script&lang=js"
export * from "./BaseCreateDialogTranslations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__